/**
 * Generates a unique React key for pages using the page's key or id.
 * This ensures each page has a stable unique identifier for React rendering.
 */
export function getPageKey(page) {
  return `${page.template_type}-${page.key || page.id}`;
}
